import { CameraGroupDetail } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useCameraGroupDetails(
  cameraGroupId: string,
  onData?: (group: CameraGroupDetail) => void
) {
  const url = `/v2/orm/camera_groups/${cameraGroupId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<CameraGroupDetail>(request, {
    queryKey: ['camera-groups', cameraGroupId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    onSuccess: onData,
  });
}

export default useCameraGroupDetails;
